import React, { useEffect } from 'react'
import { ChatBotStyles } from 'components/common/Chatbot/Chatbot.styles'

const ChatBotAqua = () => {
  useEffect(() => {
    const scriptConfig = document.createElement('script')
    scriptConfig.innerHTML = `
        window.embeddedChatbotConfig = {
          chatbotId: "g94c7IMma7GCOv86J1JkO",
          domain: "www.chatbase.co",
          showFooter: false
        };
      `
    document.body.appendChild(scriptConfig)

    const script = document.createElement('script')
    script.src = 'https://www.chatbase.co/embed.min.js'
    script.setAttribute('chatbotId', 'g94c7IMma7GCOv86J1JkO')
    script.setAttribute('domain', 'www.chatbase.co')
    script.defer = true
    script.id = 'chatbase-script' // Assign an ID for easier management
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(scriptConfig)
      const existingScript = document.getElementById('chatbase-script')
      const chatBaseButton = document.getElementById('chatbase-bubble-button')
      if (existingScript) {
        document.body.removeChild(existingScript)
      }

      if (chatBaseButton) {
        document.body.removeChild(chatBaseButton)
      }
    }
  }, [])

  return <ChatBotStyles />
}

export default ChatBotAqua
